import { Box, styled } from '@mui/material';

export const CreateSectionsLayoutsContainer = styled(Box)`
  display: flex;
  flex: 1;
  height: 100vh;
  flex-direction: row;
  padding: 0 !important;
`;

export const CreateSectionsLayoutsContentContainer = styled(Box)(
  ({ theme }) => `
  display: grid;
  grid-template-rows: auto auto auto;
  flex: 1;
  flex-direction: column;
  border-left: 1px solid ${theme.palette.secondary.light};
  overflow: auto;
  height: 100%;
`,
);
